import DesCatalogPartListViewModel from 'viewmodel/DesCatalogPartListViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';
import { DesAccConstants } from '../constant/desAccConstants';

export default class DesCatalogPartList extends DesBaseCatalogAcc {
    constructor() {
        super(DesCatalogPartListViewModel);
    }

    get contentPath() {
        return this.getAttribute('content-path');
    }

    get limit() {
        const limitStr = this.getAttribute('limit');
        if(limitStr!== null && limitStr.length > 0){
            return parseInt(this.getAttribute('limit'), 10);
        } else{
            return 50;
        }
    }

    get provider() {
        return this.getAttribute('provider');
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    get display() {
        return DesBaseCatalogAcc.getDisplayMode(this.getAttribute('display'));
    }

    get filterStatus() {
        return this.getAttribute(DesAccConstants.FILTERSTATUS);
    }

    getProps() {
        return {
            provider: this.provider,
            catalogspaceid: this.catalogspaceId,
            contentpath: this.contentPath,
            display: this.display,
            limit: this.limit,
            locale: this.locale,
            filterStatus:this.filterStatus
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'locale', 'provider',
            'catalogname', 'content-path', 'display', 'limit',DesAccConstants.FILTERSTATUS];
    }
}

if (!window.customElements.get('des-catalog-part-list')) {
    window.customElements.define('des-catalog-part-list', DesCatalogPartList);
}
